import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiCalendar } from 'react-icons/fi';
import './LatestPosts.css';
import { LatestSkeleton } from '../BlogSkeleton';

const INITIAL_COUNT = 9;

const LatestPosts = ({
  posts = [],
  categories = ['All Categories'],
  loading = false,
}) => {
  const [activeCategory, setActiveCategory] = useState('All Categories');
  const [visibleCount, setVisibleCount] = useState(INITIAL_COUNT);

  useEffect(() => {
    setActiveCategory('All Categories');
    setVisibleCount(INITIAL_COUNT);
  }, [posts]);

  const filteredPosts = useMemo(() => {
    if (activeCategory === 'All Categories') return posts;
    return posts.filter((post) => {
      if (post.industries?.length) {
        return post.industries.includes(activeCategory);
      }
      return post.category === activeCategory;
    });
  }, [activeCategory, posts]);

  const visiblePosts = filteredPosts.slice(0, visibleCount);
  const canLoadMore = visibleCount < filteredPosts.length;

  const handleCategory = (category) => {
    setActiveCategory(category);
    setVisibleCount(INITIAL_COUNT);
  };

  return (
    <section className="latest-posts">
      <div className="page-container">
        <h2>All the Latest</h2>

        <div className="latest-categories" role="tablist" aria-label="Blog categories">
          {categories.map((category) => (
            <button
              key={category}
              type="button"
              role="tab"
              aria-selected={activeCategory === category}
              className={`latest-category ${activeCategory === category ? 'active' : ''}`}
              onClick={() => handleCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>

        {loading ? (
          <LatestSkeleton />
        ) : visiblePosts.length ? (
          <>
            <div className="latest-posts-grid">
              {visiblePosts.map((post) => (
                <Link
                  key={post.id}
                  to={`/blog/${post.slug}`}
                  className="latest-card"
                >
                  <div className="latest-card-meta">
                    <span className="latest-date">
                      <FiCalendar aria-hidden="true" />
                      {post.date}
                    </span>
                    <span className="latest-category-label">
                      <span className="category-dot" aria-hidden="true" />
                      {post.category}
                    </span>
                  </div>
                  <div className="latest-card-body">
                    <div className="latest-thumb">
                      {post.image ? <img src={post.image} alt="" /> : null}
                    </div>
                    <p className="latest-card-title">{post.title}</p>
                  </div>
                </Link>
              ))}
            </div>

            {canLoadMore && (
              <div className="latest-load-more">
                <button
                  type="button"
                  onClick={() => setVisibleCount((count) => count + INITIAL_COUNT)}
                >
                  Load more posts
                </button>
              </div>
            )}
          </>
        ) : (
          <p className="blog-empty-state">No posts found.</p>
        )}
      </div>
    </section>
  );
};

export default LatestPosts;
